import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { useNavigate } from "react-router-dom";
import {
  addGRNDetailNumber,
  addPoDetailNumber,
  getGoodsReceivedNote,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CustomerConstants from "../../../../common/CustomerConstants";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
// import toast from "react-hot-toast";

const Credit_and_DebitNoteListV5 = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Credit/Debit");
  localStorage.setItem("submenu", "Credit/Debit");

  let goods_received_noteData = useSelector(
    (state) => state?.purchasing?.goods_received_note
  ); // get goods_received_note from Store

  let goods_received_noteDataTable = useSelector(
    (state) => state?.purchasing?.goods_received_note?.pagination
  ); // goods_received_noteDataTable Details from Store

  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.GRN?.module
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [filterShow, setFilterShow] = useState(false);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  /* Modal Function */
  // eslint-disable-next-line
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data

// eslint-disable-next-line
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialPageData = async (page) => {
    // let obj = {
    //   queryName: "getGrnList",
    //   page: page,
    //   per_page: getNewPerPage,
    //   // searchTerm: getCommonSearchTxt,
    // };

        // dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData.data);
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goods_received_noteData]);


// useEffect(() => {
//   let obj = {
//     queryName: "getGrnList",
//     page: 1,
//     per_page: 10,
//   };
//   dispatch(getGoodsReceivedNote(obj));
// setData(goods_received_noteData.data);

// }, [dispatch]);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getGrnList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
    // queryName: "getGrnList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      // queryName: "getGrnList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData?.data);
  };

  
// eslint-disable-next-line
  const detailedPage = (grnNumber) => {
    dispatch(addGRNDetailNumber(grnNumber));
    navigate(CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GRN_DETAILS);
  };
  // const qualityCheck = (grnNumber) => {
  //   dispatch(addGRNDetailNumber(grnNumber));
  //   navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_CREATE_MR);
  // };

  const qualityCheck = (grnNumber) => {
      // let obj = {
      //   asnNumber: "",
      //   subTransactionActivity: "PO",
      //   grnNumber: "",
      // };
          dispatch(addGRNDetailNumber(grnNumber));

      navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_CREATE_MR);
    };

    // eslint-disable-next-line
  const detailedPagePO = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
        navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_DETAILS)
    
  };
  // LocalStorage nundi userData string techukuni object ga marchali
const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");

// roles array nundi roleId ni verify cheyali
const userRoles = storedUserData?.data?.roles || [];
const isQualityCheckUser = userRoles.some(role => role.roleId === "QUALITYCHECK");
// eslint-disable-next-line
    const [getHeaderData, setHeaderData] = useState(false);  
  const columns = [

    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

{
  name: "PO/SA Number",
  cell: (row) => (
    <div className="d-flex flex-column">
      {/* PO / SA Number – keep in one line */}
      <span style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
        {row.purchasingDocumentNr || "--"}
      </span>

      {/* Date */}
      <span className="text-muted">
        {row.purchasingDocumentDate
          ? formatDateTime(row.purchasingDocumentDate)
          : "--"}
      </span>
    </div>
  ),
  sortable: true,
  width: "160px",
},

    {
      name: "Po Value",
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      width: "150px",
    },


    // {
    //   name: "PO/SA Date/Time",
    //   selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
    //   sortable: true,
    //   width: "180px",
    // },
    
    {
  name: "GRN Number",
  cell: (row) => (
    <div className="d-flex flex-column">
      {/* GRN Number – keep in one line */}
      <span style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
        {row.grnNr || "--"}
      </span>

      {/* GRN Date / Time */}
      <span className="text-muted">
        {row.createdAt
          ? formatDateTime(row.createdAt)
          : "--"}
      </span>
    </div>
  ),
  sortable: true,
  width: "200px",
},

    

...(isQualityCheckUser 
    ? [{
        name: "Quality Check",
        selector: (row) => row.grnNr,
        cell: (row) => (
          <button className="btnInfo bi bi-plus" onClick={() => qualityCheck(row.grnNr)}>
            Create
          </button>
        ),
        sortable: true,
        width: "150px",
      }] 
    : []),
   
    
    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.sumOfGrn).toFixed(2))}
          <span className="m-1 p-0 pt-1 fw-bold ms-1 text-primary">
             {row.currencyCode} 
</span>
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Nr",
      selector: (row) => row.vendorInvoiceNo || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Eway Bill Nr",
      selector: (row) => row.ewayBillNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Debit Note",
      selector: (row) => row.debitNote || "--",
      sortable: true,
      width: "150px",
    },
   
   
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: true,
      width: "140px",
    },
  
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "PO Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },

    {
      name: "GRN Quantity",
      cell: (row) => <span>{row.grnQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];

  const filterColumns = [
    {
      id: "grnStatus",
      name: "GRN Status",
      selectorKey: "grnStatus",
      dropDown: true,
    },
    {
      id: "vendorName",
      name: "Vendor Name",
      selectorKey: "vendorName",
      dropDown: true,
    },
    {
      id: "vendorTotalInvoiceValue",
      name: "Vendor Total Invoice Value",
      selectorKey: "vendorTotalInvoiceValue",
      range: true,
    },
    {
      id: "qualityCheckDate",
      name: "Quality Check Date",
      selectorKey: "qualityCheckDate",
      month: true,
    },
    {
      id: "qualityCheckStatus",
      name: "Quality Check Status",
      selectorKey: "qualityCheckStatus",
      dropDown: true,
    },
  ];
  
    const handleMultiColumnFilter = (filterResult) => {
      setFilterShow(false);
  
      let obj = {
        page: 1,
        per_page: 10,
        searchTerm: getCommonSearchTxt,
      };
  
      // Add filter if exists
      if (filterResult && filterResult.$and && filterResult.$and.length > 0) {
        obj.rowFilter = filterResult;
      }
  
      dispatch(getGoodsReceivedNote(obj));
  
    };
    //  Handle filter cancel
    const handleFilterCancel = () => {
      setFilterShow(false);
    };
  
  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.grnStatusHeader !== "Cancelled"
    );
    setSelectedRows(validRows);
  };

  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Credit & Debit Note</h2>
                <p className="subText">
                  Lists of Credit & Debit Note and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <MultiColumnFilter
                    columns={filterColumns}
                    data={goods_received_noteData?.data || []} //  Pass current vendor data for dropdown options
                    onFilter={handleMultiColumnFilter}
                    onCancel={handleFilterCancel}
                    output="and" //  Returns { $and: [...] } format
                  />
                )}
              </Col>
            </Row>


            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Credit & Debit List</span>
                      <span className="subHeaderTitle">
                        View of Credit & Debit Note and Status{" "}
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs={6} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                       <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={goods_received_noteData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={
                            goods_received_noteDataTable.total
                          }
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the GRN"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default Credit_and_DebitNoteListV5;
